'use es6';

import tinymce from 'tinymce';
import { HS_CALLOUT } from '../constants/plugins';
import { addControls } from './controls';
import { addHandlers } from './handlers';
function calloutPlugin(editor) {
  addControls(editor);
  addHandlers(editor);
}
tinymce.PluginManager.add(HS_CALLOUT, calloutPlugin);